import _extends from "@babel/runtime-corejs3/helpers/extends";
import { createVNode as _$cv, className as _$cn, createElementVNode as _$ce, noop as _$no, createUnknownComponentVNode as _$cc } from 'intact-vue-next';
import { Transition } from 'intact-vue-next';
import { expandAnimationCallbacks, getRestProps } from '../utils';
import { makeItemStyles } from './styles';
import { Icon } from '../icon';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _$cn2,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _$blocks = {};
  var __$blocks = {};
  var _this$get = this.get(),
    children = _this$get.children,
    title = _this$get.title,
    value = _this$get.value,
    className = _this$get.className,
    disabled = _this$get.disabled;
  var isActive = this.collapse.isActive(value);
  var k = this.config.k;
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-collapse-item"] = true, _classNameObj[makeItemStyles(k)] = true, _classNameObj[className] = className, _classNameObj[k + "-active"] = isActive, _classNameObj[k + "-disabled"] = disabled, _classNameObj);
  return _$cv('div', _extends({
    'className': _$cn(classNameObj)
  }, getRestProps(this)), [_$ce(2, 'div', [_$ce(2, 'div', (_$blocks['title'] = function ($super) {
    return title;
  }, __$blocks['title'] = function ($super, data) {
    var block = $blocks['title'];
    var callBlock = function callBlock() {
      return _$blocks['title'].call($this, $super, data);
    };
    return block ? block.call($this, callBlock, data) : callBlock();
  }, __$blocks['title'](_$no)), 0, _$cn(k + "-collapse-title-wrapper")), _$cc(Icon, {
    'className': _$cn((_$cn2 = {}, _$cn2[k + "-collapse-arrow"] = true, _$cn2[k + "-icon-right"] = true, _$cn2)),
    'hoverable': true,
    'disabled': disabled
  })], 4, _$cn(k + "-collapse-title"), {
    'ev-click': this.toggle
  }), _$cc(Transition, _extends({
    'show': isActive
  }, expandAnimationCallbacks, {
    'onEnter': function onEnter(el) {
      expandAnimationCallbacks.onEnter(el);
      _this.onEnter();
    },
    'onAfterLeave': function onAfterLeave(el) {
      expandAnimationCallbacks.onAfterLeave(el);
      _this.onAfterLeave();
    },
    'children': _$ce(2, 'div', children, 0, _$cn(k + "-collapse-wrapper"))
  }))]);
}
;